import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './image-input.css'

import PhotoIcon from '../../../../../assets/icons/photo.svg'

const ImageInput = ({ placeholder, isValidatingImage, onChange }) => (
  <div styleName="image">
    <input
      accept="image/jpeg,image/jpg,image/png"
      styleName="image-input"
      type="file"
      onChange={onChange}
    />
    <div styleName="image-upload">
      <PhotoIcon styleName="image-upload-icon" />
      <span styleName="image-upload-text">{isValidatingImage ? 'Loading Image...' : placeholder}</span>
    </div>
  </div>
)

ImageInput.propTypes = {
  onChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  isValidatingImage: PropTypes.bool,
}

export default CSSModules(ImageInput, styles)



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/image-input/image-input.js
 **/